/**
 * User Store Module
 */

// Dependencies
import fb from '@/lib/fb'
import path from 'path'

// Firebase Ref

// Types
import * as types from '../types'

// State
const state = {
	user: {},
	site: {},
	refs: {},
}

// Actions
const actions = {
	initUser: ({ commit }) => {
		return new Promise((resolve, reject) => {
			fb.auth().onAuthStateChanged(user => {
				if (user) {
					buildUser(user)
						.then(res => {
							commit(types.LOGIN_USER, res)
							resolve(user)
						})
				} else {
					commit(types.LOGOUT_USER)
					reject()
				}
			})
		})
	},
	loginUser: ({ commit }, login) => {
		const signin = fb.auth().signInWithEmailAndPassword(login.email, login.password)
		signin.then(res => {
			buildUser(res)
				.then(user => {
					commit(types.LOGIN_USER, user)
				})
		})
		return signin
	},
	logoutUser: ({ commit }) => {
		const signout = fb.auth().signOut()
		signout.then(res => {
			commit(types.LOGOUT_USER)
		})
		return signout
	},
	createUser: ({ rootState, bindFirebaseRef, commit }, data) => {
		const usersPath = path.join(rootState.user.refs.users)
		const usersRef = fb.database().ref(usersPath)
		const item = fb.prepIn(data)
		const newRef = usersRef.push()
		const key = newRef.key

		return new Promise((resolve, reject) => {
			newRef.set(item, res => {
				resolve(key)
			})
		})
	},
	authenticateUser: ({ commit }, data) => {
		const credential = JSON.parse(JSON.stringify(data))
		const user = fb.auth().currentUser
		return user.reauthenticateWithCredential(credential)
	},
	updatePassword: ({ rootState, commit }, data) => {
		const user = fb.auth().currentUser
		return user.updatePassword(data)
	},
	updateEmail: ({ commit }, data) => {
		const user = fb.auth().currentUser
		return user.updateEmail(data)
	},
	sendPasswordReset: ({ commit }, email) => {
		return fb.auth().sendPasswordResetEmail(email)
	},
}

async function buildUser(data) {
	const userSnap = await fb.database().ref('users').child(data.uid).once('value')
	const userData = userSnap.val()
	const user = {
		user: data,
		site: {},
		refs: {},
	}

	if (userData.siteId) {
		const siteSnap = await fb.database().ref('sites').child(userData.siteId).once('value')
		const siteData = siteSnap.val()

		if (siteData) {
			user.site = siteData

			// Firebase Refs Created based on User's Site ID
			user.refs = new fb.refs(userData.siteId)
		} else {
			return
		}
	} else {
		return
	}

	return user
}

// Mutations
const mutations = {
	[types.LOGIN_USER](state, data) {
		state.user = data.user
		state.site = data.site
		state.refs = data.refs

		// let userSnap = await fb.database().ref('users').child(data.uid).once('value')
		// let userData = userSnap.val()

		// if( userData.siteId ) {
		// 	let siteSnap  = await fb.database().ref('sites').child(userData.siteId).once('value')
		// 	let siteData = siteSnap.val()

		// 	if( siteData ) {
		// 		state.site = siteData

		// 		// Firebase Refs Created based on User's Site ID
		// 		state.refs = new fb.refs(userData.siteId)
		// 	} else {
		// 		return
		// 	}
		// } else {
		// 	return
		// }

		// state.user = Object.assign({}, userData, data)
	},

	[types.LOGOUT_USER](state) {
		state.user = {}
		state.refs = {}
		state.content = []
		state.item = {}
		state.models = []
		state.model = {}
	},

	[types.SET_SITE](state, data) {
		state.site = data
	},

	[types.UNSET_SITE](state) {
		state.site = {}
	},
}

// Getters
const getters = {
	user: state => state.user,
	site: state => state.site,
	refs: state => state.refs,
}

export default {
	state,
	actions,
	mutations,
	getters,
}



// WEBPACK FOOTER //
// ./src/lib/store/modules/user.js